import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

// 如果需要可以添加交互逻辑

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"footer-content\" data-v-0af6e58e><div class=\"project-support\" data-v-0af6e58e> 项目由好端端教育科技有限公司提供技术支持 </div><div class=\"company-info\" data-v-0af6e58e><div class=\"info-item\" data-v-0af6e58e><span data-v-0af6e58e>公司地址：</span><span data-v-0af6e58e>中国广东省深圳市南山区万科云城设计公社</span></div><div class=\"info-item\" data-v-0af6e58e><span data-v-0af6e58e>统一社会信用编码：</span><span data-v-0af6e58e>91440300MA5G7N730R</span></div><div class=\"info-item\" data-v-0af6e58e><span data-v-0af6e58e>邮箱：</span><span data-v-0af6e58e>18140543568@qq.com</span></div></div><div class=\"footer-nav\" data-v-0af6e58e><a href=\"#\" class=\"nav-item\" data-v-0af6e58e>关于好端端</a><a href=\"#\" class=\"nav-item\" data-v-0af6e58e>产品功能</a><a href=\"#\" class=\"nav-item\" data-v-0af6e58e>服务条款</a></div></div>", 1)
  ])))
}
}

})